import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'transactions',
        (state.get('transactions') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, action) {
    return state.set(
        'transactions',
        (state.get('transactions') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state, action) {
    return state
        .set(
            'transactions',
            (state.get('transactions') || Map())
                .set('hasNextPage', action.hasNextPage)
                .set('list', fromJS(action.transactions))
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('transactions', Map());
}
